var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultipleUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59999 6.39961C6.92548 6.39961 7.99999 5.32509 7.99999 3.99961C7.99999 2.67413 6.92548 1.59961 5.59999 1.59961C4.27451 1.59961 3.19999 2.67413 3.19999 3.99961C3.19999 5.32509 4.27451 6.39961 5.59999 6.39961Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 7.19961C12.7046 7.19961 13.6 6.30418 13.6 5.19961C13.6 4.09504 12.7046 3.19961 11.6 3.19961C10.4954 3.19961 9.59999 4.09504 9.59999 5.19961C9.59999 6.30418 10.4954 7.19961 11.6 7.19961Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.29222 13.142C0.974374 12.9385 0.790272 12.5764 0.836834 12.2019C1.13132 9.83322 3.15154 7.99961 5.59991 7.99961C8.04828 7.99961 10.0685 9.83271 10.363 12.2013C10.4096 12.5759 10.2255 12.9379 9.90762 13.1414C8.66417 13.9376 7.18594 14.3996 5.59991 14.3996C4.01389 14.3996 2.53567 13.9381 1.29222 13.142Z",
    fill: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 12.7996C11.5718 12.7996 11.5436 12.7994 11.5154 12.799C11.5705 12.5616 11.5858 12.3104 11.5538 12.0533C11.4135 10.9246 10.9601 9.89324 10.2832 9.04893C10.6917 8.888 11.1366 8.79961 11.6022 8.79961C13.154 8.79961 14.4765 9.78146 14.9823 11.1578C15.091 11.4537 14.9636 11.7789 14.6937 11.9416C13.7903 12.4863 12.7318 12.7996 11.6 12.7996Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleUser);
export default __webpack_public_path__ + "static/media/multiple_user.fb24d857892542f54bdb3030cecf29e3.svg";
export { ForwardRef as ReactComponent };